import {
  formatTimestamp,
  truncate,
  formatEventsForClipboard,
} from './formatters';

describe('formatTimestamp', () => {
  it('formats an ISO string to readable format', () => {
    expect(formatTimestamp('2026-03-25T16:41:52.000Z')).toBe(
      '2026-03-25 16:41:52.000',
    );
  });

  it('formats a numeric epoch timestamp', () => {
    const result = formatTimestamp(1711400000000);
    expect(result).toMatch(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{3}$/);
  });

  it('returns empty string for falsy input', () => {
    expect(formatTimestamp(null)).toBe('');
    expect(formatTimestamp(undefined)).toBe('');
    expect(formatTimestamp('')).toBe('');
  });

  it('returns the original value as string for unparseable input', () => {
    expect(formatTimestamp('not-a-date')).toBe('not-a-date');
  });
});

describe('truncate', () => {
  it('returns the string unchanged if shorter than limit', () => {
    expect(truncate('hello', 10)).toBe('hello');
  });

  it('truncates and adds ellipsis if longer than limit', () => {
    expect(truncate('hello world', 5)).toBe('hello...');
  });

  it('returns empty string for falsy input', () => {
    expect(truncate(null, 10)).toBe('');
    expect(truncate('', 10)).toBe('');
  });
});

describe('formatEventsForClipboard', () => {
  const events = [
    {
      '@id': 'evt-1',
      '@timestamp': '2026-03-25T16:41:52.000Z',
      Level: 'INFO',
      message: 'Request started',
      controller: 'CasesController',
      action: 'show',
    },
    {
      '@id': 'evt-2',
      '@timestamp': '2026-03-25T16:41:53.000Z',
      Level: 'ERROR',
      message: 'Something went wrong',
      backtrace: 'app/controllers/cases_controller.rb:42',
    },
  ];

  it('returns empty string for empty or null events', () => {
    expect(formatEventsForClipboard([], 'x')).toBe('');
    expect(formatEventsForClipboard(null, 'x')).toBe('');
  });

  it('includes full event JSON for each event', () => {
    const result = formatEventsForClipboard(events, 'evt-2');

    expect(result).toContain('"message": "Request started"');
    expect(result).toContain('"controller": "CasesController"');
    expect(result).toContain(
      '"backtrace": "app/controllers/cases_controller.rb:42"',
    );
  });

  it('marks the anchor event with [ANCHOR] prefix', () => {
    const result = formatEventsForClipboard(events, 'evt-2');

    expect(result).toContain('[ANCHOR] --- 2026-03-25 16:41:53.000  ERROR ---');
    expect(result).not.toMatch(/\[ANCHOR\].*INFO/);
  });

  it('includes timestamp and level in the header line', () => {
    const result = formatEventsForClipboard(events, 'evt-2');

    expect(result).toContain('--- 2026-03-25 16:41:52.000  INFO ---');
    expect(result).toContain('--- 2026-03-25 16:41:53.000  ERROR ---');
  });

  it('separates events with blank lines', () => {
    const result = formatEventsForClipboard(events, 'evt-2');

    expect(result).toContain('}\n\n');
  });
});
